export default {
  path: '/distributor/tour/front/preview',
  name: `distributor-tour-front-preview`,
  component: () => import(`./index.vue`),
  meta: {
    skip_check_token: true,
  },
};
